module.exports = __webpack_public_path__ + "static/coop-73eb42347928dd9d61121343add20b7b.png";